import {BaseFirebaseModel} from '../bases/baseFirebaseModel';
import {InvitationStatus} from '@enums';

export class Invitation extends BaseFirebaseModel {
	sender: string;
	receiver: string;
	status: InvitationStatus;
	message: string;

	constructor(message: string, receiver: string, id?: string, sender: string = '', status: InvitationStatus = InvitationStatus.pending, createdAt: Date = new Date()) {
		super(id);
		// automatiquement rempli lors de l'envoie de l'invitation par l'id de l'utilisateur connecté si non spécifié.
		this.sender = sender;
		this.receiver = receiver;
		this.status = status;
		this.createdAt = createdAt;
		this.message = message;
	}

	static override fromObject(obj: Record<string, unknown>) {
		const invit = super.fromObject(obj);
		invit.createdAt = new Date(invit.createdAt);
		return invit;
	}

	override toFirebase() {
		const invit = super.toFirebase();
		invit.createdAt = this.createdAt.valueOf();
		return invit;
	}
}
